export const emotionDescription = {
  "😊": {
    name_ko: ["행복함", "행복한 분위기"],
    name_en: ["Happiness"]
  },
    "😆": {
    name_ko: ["즐거움", "재미있음"],
    name_en: ["Pleased","Enthusiastic"]
  },
    "😍": {
    name_ko: ["사랑", "하트"],
    name_en: ["Love","Heart"]
  },
    "☺": {
    name_ko: ["소극적인", "민망한", "부끄러움"],
    name_en: ["Timid","Red-Faced"]
  },
    "💆": {
    name_ko: ["편안함", "여유로운", "휴식을 취하다"],
    name_en: ["Relax","Comfortable","Rest"]
  },
    "😲": {
    name_ko: ["놀라다", "충격받다"],
    name_en: ["Surprise","Shocked","Omg"]
  },
    "😅": {
    name_ko: ["당혹스럽다", "난처하다"],
    name_en: ["Confused","Flustered"]
  },
    "😒": {
    name_ko: ["짜증나다", "불쾌하다"],
    name_en: ["Annoy","Unpleasant"]
  },
    "😡": {
    name_ko: ["화나다", "분노하다"],
    name_en: ["Anger","Rage"]
  },
    "😞": {
    name_ko: ["좌절하다", "실망스럽다"],
    name_en: ["Dissatisfied","Despair"]
  },
    "😢": {
    name_ko: ["슬프다", "상처받다", "눈물을 흘리다"],
    name_en: ["Sadness","Tears"]
  },
    "🙇": {
    name_ko: ["잘못하다", "용서를 빌다"],
    name_en: ["Apology","Regret"]
  },
    "😱": {
    name_ko: ["겁을 먹다", "두려워하다"],
    name_en: ["Afraid","Frightful"]
  },
    "😐": {
    name_ko: ["무표정", "관심없음"],
    name_en: ["Neutral face","Uninterested"]
  },
    "🤤": {
    name_ko: ["배가 고프다", "식욕이 있다"],
    name_en: ["Hunger","Starving"]
  },
    "😪": {
    name_ko: ["졸리다", "눈꺼풀이 무거움","꾸벅꾸벅"],
    name_en: ["Sleepy","Yawn","Heavy eyes"]
  },
    "😴": {
    name_ko: ["한숨 자다", "자러 가다", "수면 중"],
    name_en: ["Fall asleep","Sleeping","Napping"]
  },
    "👍": {
    name_ko: ["엄지 손가락을 올리는 행동"],
    name_en: ["Act of thumb up"]
  },
    "🤣": {
    name_ko: ["빵 터짐", "박장대소"],
    name_en: ["LoL","Crying laughting"]
  },
    "😜": {
    name_ko: ["장난치다", "농담하다", "익살스러운"],
    name_en: ["Teasing","gag"]
  },
    "😉": {
    name_ko: ["귀여운 행동", "예쁜 척하다","윙크 하다"],
    name_en: ["Winking","Cute acting"]
  },
    "🤨": {
    name_ko: ["의심스러운", "수상함", "불확실함"],
    name_en: ["Suspicious","Doubtful"]
  },
    "😑": {
    name_ko: ["심심하다", "지루하다"],
    name_en: ["Tedious","Dull"]
  },
    "🤔": {
    name_ko: ["생각 중", "고민 중"],
    name_en: ["Thinking","Agonize"]
  },
    "😩": {
    name_ko: ["피곤하다", "힘들다", "지치다"],
    name_en: ["Tired face","Exhausting"]
  },
    "🙃": {
    name_ko: ["비꼬다", "빈정거리다"],
    name_en: ["Sarcasm","Ironic"]
  },
    "😣": {
    name_ko: ["인내하다", "고통을 견디다"],
    name_en: ["Tolerate","Hold on"]
  },
    "😶": {
    name_ko: ["침묵", "정적", "말을 잃다"],
    name_en: ["Soundless","Calm"]
  },
    "😀": {
    name_ko: ["빙그레 웃다", "미소짓는 모습"],
    name_en: ["Slight smile"]
  },
    "🤗": {
    name_ko: ["다독이다", "껴안다"],
    name_en: ["Reassure","Hug"]
  },
    "🤩": {
    name_ko: ["엄청나다", "놀랍다"],
    name_en: ["Wonderful","Amazing"]
  },
    "😏": {
    name_ko: ["조롱하다", "교활하다"],
    name_en: ["Ridicule","half smile","Mischievous"]
  },
    "😋": {
    name_ko: ["배부름", "포만감"],
    name_en: ["Stuffed","Be full"]
  },
    "🤪": {
    name_ko: ["미치광이", "정신나감", "엉뚱하다"],
    name_en: ["Madness","Act crazy"]
  },
    "😰": {
    name_ko: ["걱정하다", "긴장하다"],
    name_en: ["Under pressure","Concerned"]
  },
    "🥴": {
    name_ko: ["술에 취하다", "취해서 헤롱헤롱하다"],
    name_en: ["Drunken","Woozy with alcohol"]
  },
    "🥺": {
    name_ko: ["소원", "~을 바라다", "~을 갖고싶다"],
    name_en: ["Desired","Wanting"]
  },
    "😤": {
    name_ko: ["고집불통이다", "삐지다"],
    name_en: ["Sulk","Haughty"]
  },
    "😵": {
    name_ko: ["의식이 없다", "어지럽다"],
    name_en: ["Unconscious","Dizzy eye"]
  },
    "🙄": {
    name_ko: ["딴청을 피우다", "시침을 떼다"],
    name_en: ["So what","Eye roll"]
  },
    "😎": {
    name_ko: ["자신감 있는", "멋있는"],
    name_en: ["Cool","Confident"]
  },
    "🤦": {
    name_ko: ["창피하다", "수치스럽다"],
    name_en: ["Shame","Frustrated"]
  },
    "🤷": {
    name_ko: ["모르겠다", "어깨를 으쓱하다"],
    name_en: ["Don't know","Shrugging action"]
  },
    "☠": {
    name_ko: ["해골", "위험한"],
    name_en: ["Skeleton","Toxic"]
  },
    "🤏": {
    name_ko: ["조금 있는", "작다"],
    name_en: ["Small amount","Mini"]
  },
    "👎": {
    name_ko: ["별로다", "엄지를 아래로 내리다"],
    name_en: ["Moving thumbs down"]
  },
    "💪": {
    name_ko: ["근육", "근육을 자랑하다"],
    name_en: ["Showing muscle"]
  },
    "🕴": {
    name_ko: ["외로운", "고독한"],
    name_en: ["All alone","Isolated"]
  },
    "😌": {
    name_ko: ["안도하는", "안심을 하다"],
    name_en: ["Feel easy"]
  },
    "💔": {
    name_ko: ["헤어지다"],
    name_en: ["Heartbroken", "Break up"]
  } 
}